<script setup lang="ts">
import FormCard from "~/components/ui/FormCard.vue";
import PrecompiledBox from "~/components/ui/PrecompiledBox.vue";
import PrecompiledField from "~/components/inputs/PrecompiledField.vue";
import SelectDate from "~/components/inputs/SelectDate.vue";
import BackButton from "~/components/inputs/BackButton.vue";
import { useFormContainer } from "~/composables/useFormContainer";
import precompiledDocumentRules from "~/themes/cliente-pz/rules/precompiledDocument";
import Validator from "~/utils/validator";
import { useVuelidate } from "@vuelidate/core";
import { DateTime } from "luxon";
import Pencil from "~/components/icons/Pencil.vue";

defineComponent({
  name: "PrecompiledDocument"
})

const {progress, title, stickyButton } = defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  stickyButton: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "goBack", "goAltForm"]);

onMounted(() => {
  emit("init");
});

const maskedDocumentNumber = useState<string | null>("maskedDocumentNumber", () => null);
const documentCity = useState<string | null>("documentCity", () => null);
const documentExpire = useState<string | null>("documentExpire", () => null);
const documentRelease = useState<string | null>("documentRelease", () => null);

const maxYearExpire = computed(() => {
  const currentDate = DateTime.now();
  const maxDate = currentDate.plus({ years: 11 });
  return maxDate.year;
});

const minYearExpire = computed(() => {
  const currentYear = DateTime.now();
  return currentYear.year;
});

const v$ = useVuelidate(precompiledDocumentRules, {
  documentExpire,
});

const validate = () => {
  v$.value.$touch();
  v$.value.$validate();
  return !v$.value.$error;
};

const submit = () => {
  if (validate()) {
    emit("submit");
  }
};

</script>

<template>
  	<FormContainer class="precompiled-document" :progress="progress">
      <FormCard :title="title" @submit="submit" :has-sticky-button="stickyButton">
        <PrecompiledBox :editable="false" :value="false">
          <PrecompiledField
            label="Numero della patente"
            v-model="maskedDocumentNumber"
            type="text"
            test-id="documentNumber"
            class="md:w-1/2 lg:w-1/3"
          />
          <PrecompiledField
            label="Comune di rilascio"
            v-model="documentCity"
            type="text"
            test-id="documentCity"
            class="md:w-1/2 lg:w-1/3"
          />
          <PrecompiledField
            label="Data di rilascio"
            v-model="documentRelease"
            type="text"
            test-id="documentCity"
            class="md:w-1/2 lg:w-1/3"
          />
        </PrecompiledBox>
        <div class="w-full lg:px-6 mt-3 mb-4">
          <div class="w-full">
              <label class="text-xs mb-2 block">Data di scadenza (punto 4b)</label>
              <SelectDate
                v-model="documentExpire"
                :start-year="minYearExpire"
                :end-year="maxYearExpire"
                :error="v$.documentExpire.$error"
                :error-message="Validator.message(v$.documentExpire)"
                test-id="documentExpire"
              />
            </div>
        </div>
        <template #link>
          <BackButton :event="`goBack`" @go-back="$emit('goBack')" />
          <!-- <button 
            type="button" 
            class="text-left w-full bg-yellow px-8 md:px-12 py-3 flex justify-between items-center mb-10" 
            @click="$emit('goAltForm')"
          >
            <p class="max-w-[90%] text-[14px]">
              Non hai la patente con te e vuoi inserire un altro documento? 
              <span class="inline underline">Clicca qui</span>
            </p>
            <Pencil />
          </button> -->
        </template>
      </FormCard>
    </FormContainer>
</template>
